import React from 'react';
import { useLang } from '../../hooks/useLang';

import { FlagES, FlagUK } from './Flags';

const LanguageToggle = () => {
    const { t, lang, setLang } = useLang();

    const toggleLanguage = () => {
        setLang(lang === 'es' ? 'en' : 'es');
    };

    return (
        <button
            type="button"
            onClick={toggleLanguage}
            className={`btn-floating-control ${lang !== 'es' ? 'active-state' : ''}`}
            aria-label={lang === 'es' ? t('controls.lang.switch_en') : t('controls.lang.switch_es')}
            title={lang === 'es' ? t('controls.lang.switch_en') : t('controls.lang.switch_es')}
        >
            {lang === 'es' ? <FlagES /> : <FlagUK />}
        </button>
    );
};

export default LanguageToggle;

